import { render, staticRenderFns } from "./TheLanguageSwitcher.vue?vue&type=template&id=0e57f171"
import script from "./TheLanguageSwitcher.vue?vue&type=script&lang=js"
export * from "./TheLanguageSwitcher.vue?vue&type=script&lang=js"
import style0 from "./TheLanguageSwitcher.vue?vue&type=style&index=0&id=0e57f171&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports